import { reverseGeocodePhoton } from './geocodeSearch';
import { distanceKm } from './geo';

function normalizeName(name) {
  return String(name || '')
    .trim()
    .toLowerCase();
}

function matchKnownCity(name, cities) {
  const n = normalizeName(name);
  if (!n) return null;
  return (cities || []).find((c) => normalizeName(c?.cityName) === n) || null;
}

function nearestCity(lat, lng, cities, maxKm) {
  let best = null;
  let bestD = Infinity;
  for (const city of cities || []) {
    const clat = city?.location?.latitude;
    const clng = city?.location?.longitude;
    if (typeof clat !== 'number' || typeof clng !== 'number') continue;
    const d = distanceKm(lat, lng, clat, clng);
    if (d < bestD) {
      bestD = d;
      best = city;
    }
  }
  if (best && bestD <= maxKm) return best;
  return null;
}

/**
 * Best short city label for GPS coords: known city list, then reverse geocode.
 * @returns {Promise<string | null>}
 */
export async function resolveGpsCityName(lat, lng, cities = []) {
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;

  let photonName = '';
  try {
    const parsed = await reverseGeocodePhoton(lat, lng);
    photonName = (parsed?.cityName || parsed?.name || '').trim();
  } catch {
    photonName = '';
  }

  const knownExact = matchKnownCity(photonName, cities);
  if (knownExact?.cityName) return knownExact.cityName;

  const nearby = nearestCity(lat, lng, cities, 50);
  if (nearby?.cityName) return nearby.cityName;

  return photonName || null;
}
